<div class="contact-modal">
  <form [formGroup]="contactForm" class="contact-modal__form">
    <h2 class="contact-modal__title">Talk to a representative</h2>

    <div class="contact-modal__field">
      <label class="contact-modal__label" translate>First Name*</label>
      <input
        appNoLeadingSpace
        class="input-contactswap sm"
        formControlName="firstName"
        minlength="3"
        type="text"
        pInputText
      />
    </div>
    <div class="contact-modal__field">
      <label class="contact-modal__label" translate>Last Name*</label>
      <input
        appNoLeadingSpace
        class="input-contactswap sm"
        formControlName="lastName"
        minlength="3"
        type="text"
        pInputText
      />
    </div>
    <div class="contact-modal__field">
      <label class="contact-modal__label" translate>Phone Number*</label>
      <p-inputmask
        autocomplete="tel"
        formControlName="mobileNumber"
        inputmode="tel"
        mask="+1 (999) 999-9999"
        size="30"
        styleClass="input-contactswap sm novalidate"
        type="tel"
      />
    </div>
    <div class="contact-modal__field">
      <label class="contact-modal__label">Email*</label>
      <input
        appNoLeadingSpace
        class="input-contactswap sm"
        formControlName="emailId"
        pInputText
        type="text"
      />
    </div>
    <div class="contact-modal__field">
      <label class="contact-modal__label">Company Name*</label>
      <input
        appNoLeadingSpace
        class="input-contactswap sm"
        formControlName="companyName"
        minlength="3"
        type="text"
        pInputText
      />
    </div>

    <h5 class="contact-modal__phone">Or call us at: +1 (832) 412-4070</h5>
    <div class="contact-modal-buttons">
      <div class="contact-modal-buttons__item">
        <button
          (click)="onCancelButtonClick()"
          class="button-simple lg-20 bg-darkgray white no-margins full-width"
        >
          {{ 'CANCEL' | uppercase }}
        </button>
      </div>
      <div class="contact-modal-buttons__item">
        <button
          (click)="onContactButtonClick()"
          [disabled]="contactForm.invalid"
          class="button-simple lg-20 shock-pink uppercase full-width"
        >
          Contact Me
        </button>
      </div>
    </div>
  </form>
</div>
